import { useEffect } from 'react';

const TawkToChat = () => {
  useEffect(() => {
    // Inject left-positioning CSS before widget loads
    const style = document.createElement('style');
    style.id = 'tawk-position-override';
    style.innerHTML = `
      /* Move Tawk.to widget to the bottom-left */
      .tawk-min-container,
      .tawk-button-circle,
      div[id^="tawkchat-minified-"] {
        left: 20px !important;
        right: auto !important;
      }
      /* Move the chat window itself to bottom-left */
      .tawk-chat-panel,
      div[id^="tawkchat-container-"] {
        left: 20px !important;
        right: auto !important;
      }
    `;
    document.head.appendChild(style);

    // Avoid loading the script twice (e.g. React StrictMode double-invoke)
    if (document.getElementById('tawk-script')) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    // Position widget on the left via Tawk API customStyle
    window.Tawk_API.customStyle = {
      visibility: {
        desktop: { position: 'bl', xOffset: 20, yOffset: 20 },
        mobile:  { position: 'bl', xOffset: 10, yOffset: 10 },
      },
    };

    // Tawk loads as a side-effect of inserting this script tag
    const s1 = document.createElement('script');
    s1.id = 'tawk-script';
    s1.async = true;
    s1.src = 'https://embed.tawk.to/69a55cb8b0555e1c3f0ba96e/1jimv4cj8';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');

    const s0 = document.getElementsByTagName('script')[0];
    s0.parentNode.insertBefore(s1, s0);

    return () => {
      // Cleanup on unmount — hide the widget
      if (window.Tawk_API && window.Tawk_API.hideWidget) {
        window.Tawk_API.hideWidget();
      }
    };
  }, []);

  // This component renders nothing — Tawk injects its own UI
  return null;
};

export default TawkToChat;
